import { render } from "./MenuValueConfig.vue?vue&type=template&id=b07e2dee&scoped=true"
import script from "./MenuValueConfig.vue?vue&type=script&lang=js"
export * from "./MenuValueConfig.vue?vue&type=script&lang=js"

import "./MenuValueConfig.vue?vue&type=style&index=0&id=b07e2dee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b07e2dee"]])

export default __exports__